import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromLoad from '../_reducers/load';

export const selectLoadState = createFeatureSelector<fromLoad.LoadState>('loads');

export const selectAllLoads = createSelector(selectLoadState, fromLoad.selectAll);

export const selectLoadEntities = createSelector(selectLoadState, fromLoad.selectEntities);

export const selectLoadById = (id: number) =>
  createSelector(selectLoadEntities, (entities) => entities[id]);

export const selectLoadTotal = createSelector(selectLoadState, fromLoad.selectTotal);
